<h3>{{ 'events.settings.notifications.title' | translate | titlecase }}</h3>
<div class="mt-27 mb-50">
  <div *ngFor="let notifyEmail of event.EventSignUpNotificationEmails">
    <div class="mct-flex mct-row mct-gap-27">
      <div class="w-100 mct-flex mct-col">
        <label>
          {{ 'common.personal-information.email' | translate | titlecase }}
        </label>
        <input
          class="form-control"
          type="email"
          name="email"
          [(ngModel)]="notifyEmail.Email"
          [placeholder]="'common.personal-information.email' | translate | titlecase"
        />
      </div>
      <div class="w-100 mct-flex mct-col">
        <label> {{ 'events.settings.general.component.email-notification-user-label' | translate | titlecase }}</label>
        <wl-user-selector
          [(ngModel)]="notifyEmail.UserNum"
          (selectedUserChanged)="selectedNotifyUserChangedHandler($event, notifyEmail)"
        ></wl-user-selector>
      </div>
    </div>
    <div class="mv-27 mct-flex mct-row mct-gap-27">
      <div class="w-100 mct-flex mct-col">
        <label>
          {{ 'common.personal-information.first-name' | translate | titlecase }}
        </label>
        <input
          class="form-control"
          type="text"
          name="firstname"
          [(ngModel)]="notifyEmail.FirstName"
          [placeholder]="'common.personal-information.first-name' | translate | titlecase"
        />
      </div>
      <div class="w-100 mct-flex mct-col">
        <label>
          {{ 'common.personal-information.last-name' | translate | titlecase }}
        </label>
        <input
          class="form-control"
          type="text"
          name="lastname"
          [(ngModel)]="notifyEmail.LastName"
          [placeholder]="'common.personal-information.last-name' | translate | titlecase"
        />
      </div>
    </div>
    <button pButton type="button" class="atlas-btn atlas-btn-danger" (click)="removeNotificationEmail(notifyEmail)">
      {{ 'common.delete' | translate | titlecase }}
    </button>
    <hr />
  </div>

  <button
    app-add-button
    class="atlas-btn atlas-btn-primary"
    [label]="'events.settings.general.component.new-email-notifications-label' | translate | titlecase"
    (click)="addNewNotificationEmail()"
  ></button>
</div>

<div class="mt-80 mb-80">
  <wl-event-v4-settings-notification-reminder [event]="event"></wl-event-v4-settings-notification-reminder>
</div>

<div>
  <h3>{{ 'events.settings.notifications.event-confirmation-email' | translate | titlecase }}</h3>
  <div class="mv-27">
    <label>
      {{ 'events.settings.registration-settings.event-event-confirmation-email-from-label' | translate }}
    </label>
    <div class="w-50">
      <input type="text" class="form-control" [(ngModel)]="event.Email" />
    </div>
  </div>
  <div>
    <p-checkbox [(ngModel)]="event.EnableAttendeeConfirmations" [binary]="true" inputId="enableAttendeeConfirmations"> </p-checkbox>
    <label for="enableAttendeeConfirmations">
      {{ 'events.settings.registration-settings.enable-confirmation-email-to-attendees-label' | translate | titlecase }}
    </label>
  </div>
  <div class="mt-27 mct-flex mct-row mct-justify-between mct-items-stretch">
    <label>{{ 'events.settings.registration-settings.confirmation-message' | translate | titlecase }}</label>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-default"
      icon="pi pi-eye"
      [label]="'common.preview' | translate | titlecase"
      [disabled]="loadingConfirmationMessagePreview"
      (click)="previewConfirmationMessage()"
    >
      <wl-busy [show]="loadingConfirmationMessagePreview"></wl-busy>
    </button>
  </div>

  <div>
    <div>
      <wl-modular-wysiwyg-editor
        #messageMessageField="ngModel"
        name="regEditor"
        [editorName]="'regEditor'"
        [(ngModel)]="event.ConfirmationMessage"
        [emailContent]="true"
        [quickInsertListLabel]="'communications.mass-comm-message-edit.message-edit.special-fields-dropdown-label' | translate"
        [showHtmlTemplates]="true"
      ></wl-modular-wysiwyg-editor>
    </div>
  </div>
</div>
